const routerH5 = [{
    path: 'index',
    name: '首页H5',
    component: () => import('@/views/shopDecoration/views/indexH5.vue'),
  },
  {
    path: "special",
    name: "专题页H5",
    component: () => import("@/views/shopDecoration/views/specialH5.vue"),
  },
  {
    path: 'information',
    name: '资讯分类H5',
    component: () => import('@/views/mobile/views/news/list.vue'),
  },
  {
    path: 'newsDetail',
    name: '资讯详情H5',
    component: () => import('@/views/mobile/views/news/detail.vue'),
  },
  // ========== 调试路由（生产环境请删除）==========
  {
    path: 'share-debug',
    name: '微信分享调试',
    component: () => import('@/views/test/ShareDebug.vue'),
  },
  // ========== 调试路由结束 ==========
]
module.exports = routerH5;